<template>
  <div class="about-us-page">
    <div class="nav-page-box">
      <nav-page-view
        :tabHoverPage="4"
      ></nav-page-view>
    </div>
    <div class="about-us-banner">
      <img :src="aboutUsBanner" alt="">
      <div>
        <banner-page-view
          :titleObj="aboutUsObj"
        ></banner-page-view>
      </div>
    </div>
    <div class="about-content-box">
      <div class="about-content flex-middle-x layout-flex-center">
        <ul>
          <li class="flex-middle-x" v-for="item in aboutList">
            <img :src="item.image" alt="">
            <div>
              <h5>{{item.title}}</h5>
              <p>{{item.content}}</p>
            </div>
          </li>
        </ul>
        <img class="about-content-image" :src="aboutContentImage" alt="">
      </div>
    </div>
    <div class="other-map-view">
      <other-map-view :mapMessage="mapMessage"></other-map-view>
    </div>
    <div class="location-city">
      <div class="location">
        <h4>上海金保证网络科技有限公司</h4>
        <p>地      址：上海闵行区宜山路1618号新意城C栋308</p>
        <p>电      话：021-61921322</p>
        <p>客服热线：021-61921322</p>
        <p>邮      箱：pengdashuai@jinbaozheng.com</p>
        <div class="flex-middle-x">
          <p><img :src="wx" alt=""><br><span>官方微信</span></p>
          <p><img :src="app" alt=""><br><span>APP下载</span></p>
        </div>
      </div>
    </div>
    <div class="footer-page-box">
      <footer-page-view
      ></footer-page-view>
    </div>
  </div>
</template>
<script>
  import OtherMapView from '@/components/computer/other/OtherMapView';
  export default {
    name:'',
    data(){
      return {
        mapMessage:{
          address:'上海金保证网络科技有限公司',
          latitude: 31.176228,
          longitude: 121.40004,
          name: '',
          phone: '021-61921332'
        },
        aboutUsBanner: require('./image/about-us-banner-image.jpg'),
        aboutContentImage: require('./image/about-content-image.png'),
        aboutUsObj:{
          mainHeading:'关于我们',
          subhead:'力致打造行业领导者',
          content:'Shanghai golden guarantee network technology co. LTD'
        },
        wx:require('./image/wx.png'),
        app:require('./image/app.png')
      }
    },
    components:{
      'other-map-view':OtherMapView
    },
    computed:{
      aboutList(){
        return [
          {image:require('./image/client.png'), title:'尊重客户', content:'以客户为中心，用心服务客户；勇于承担企业的责任帮助企业实现目标； 为客户提供卓越的服务体验。'},
          {image:require('./image/science.png'), title:'技术领先', content:'与国际专业协会合作并且高度互动； 前瞻性的引领和满足客户需求；技术和人才的整合，为行业跟随者提供最佳实践； 创造行业最佳实践建立价值观体系。'},
          {image:require('./image/method.png'), title:'方法落地', content:'提供以客户需求为导向的解决方案； 采取多种方式加大企业参与力度； 针对项目不同内容，采取不同的方法协助企业实施落地'}
        ]
      }
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped="">
  .about-us-page{
    .about-us-banner{
      width:100%;
      min-width:1200px;
      position: relative;
      height:450px;
      overflow: hidden;
      img{
        width:100%;
        min-height:450px;
      }
      div{
        width:600px;
        position: absolute;
        top:50%;left:50%;
        transform: translate(-50%, -50%);
      }
    }
    .about-content-box{
      width:100%;
      background:$color-4;
      padding-top:90px;
      .about-content{
        width:1200px;
        margin:auto;
        ul{
          li{
            text-align: left;
            margin-bottom:50px;
            img{
              width:70px;
            }
            div{
              padding-left:20px;
              h5{
                font-size:20px;
                color:#555555;
                margin-top:10px;
              }
              p{
                font-size:16px;
                color:$color-3;
              }
            }
          }
        }
        .about-content-image{
          width:500px;
          padding-left:100px;
        }
      }
    }
    .location-city{
      width:100%;
      background:$color-4;
      padding-top:44px;
      padding-bottom:105px;
      .location{
        width:1200px;
        margin:auto;
        text-align: left;
        h4{
          font-size:24px;
          color:#333333;
        }
        p{
          font-size:16px;
          color:#555555;
          margin-top:20px;
        }
        div{
          margin-top:50px;
          text-align: center;
          p{
            padding-right:50px;
            img{
              width:130px;
            }
            span{
              font-size:16px;
              color:$color-black;
            }
          }
        }
      }
    }
  }
</style>
